export const ADMIN_NAV_ROLES = ['moderator', 'admin', 'super_admin'];
export const USER_MANAGEMENT_ROLES = ['admin', 'super_admin'];
export const ROLE_EDIT_ROLES = ['super_admin'];

export function hasAnyRole(user, allowed = []) {
  return allowed.includes(String(user?.role || 'user'));
}
